<template>
  <div v-if="transcripts && transcripts.length">
    <AthleteSectionSubheading>Transcripts</AthleteSectionSubheading>
    <div class="mb-8 linkGrid">
      <AthleteLinkCard
        class="w-full"
        v-for="(link) in sortedTranscripts"
        :key="link.id"
        :document="link"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AthleteSectionSubheading from "../../AthleteSectionSubheading.vue";
import AthleteLinkCard from "../../AthleteLinkCard.vue";

export default {
  components: {
    AthleteSectionSubheading,
    AthleteLinkCard
  },
  computed: {
    ...mapState({
      transcripts: state => state.athleteProfile.user.transcripts
    }),
    sortedTranscripts() {
      return this.transcripts.sort((a,b) => a.order - b.order)
    }
  }
};
</script>

<style lang="scss">
  .linkGrid {
    display: grid; 
    grid-template-columns: repeat(auto-fill, minmax(344px, 1fr)); 
    grid-gap: 1rem;
  }
</style>